import React, { useState, useEffect } from "react";
import FontAwesome from "react-fontawesome";
import { getMonthpay, getCarRate } from "../../services/car";
import ModalUpload from "./modalupload";
import Input from "./../common/inputfunction";

import "./../../card.css";
import Monthtogle from "./rendermonthtogle";



const Monthlist = ({ year, month, id }) => {
  const [listmonth, setlistmonth] = useState([]);
  const [payamout, setpayamout] = useState(0);
  const [from, setfrom] = useState(0);
  const [to, setto] = useState(0);
  const [eanableupload, setenableupload] = useState(true);
  const [rate, setrate] = useState(0);
  const [finerate, setfinerate] = useState(0);
  const [finedate, setfinedate] = useState(0);
  const [chkfine, setchkfine] = useState(0);
  const [totalfine, settotalfine] = useState(0);
  
  const [error, seterror] = useState("");
  const [openUpload, setopenUpload] = useState(false);
  const [totalmonth, settotalmonth] = useState(0);
  
  const [monthselect, setmonthselect] = useState({});

  useEffect(() => {
    const loadData = async () => {
      const { data: result } = await getCarRate(id);
      if (result.status === "success") {

        setfinerate(result.data.fine);
        setchkfine(result.data.finemonth)
        setrate(result.data.rate);
        setfinedate(result.data.finedate)
        settotalfine(calTotalfine(result.data.fine,result.data.finemonth,result.data.finedate))
      //  settotalfine(calTotalfine(result.data.fine,1,1))
     
      }
    };
    loadData();
  }, [id]);


  useEffect(() => {
    const loadData = async () => {
      const { data: result } = await getMonthpay(year, id);
      if (result.status === "success") {
        setlistmonth(result.data.list);
      }
    };
    loadData();
  }, [year, id]);


useEffect(() =>{

  
 
  const calfineday = () =>{

  
      


  };
  calfineday();

},[]) 


  const handleChangeToggleMonth = (event, id, name, disabled) => {
  //   console.log('log',event, id, name, disabled)

  seterror("");
    const  checked  = event;
    const toggle = {
      _id: id,
      name: name,
      chkselected: checked,
      disabled: disabled,
    };
    const subDAP = [...listmonth];
    const Index = subDAP.findIndex((x) => x._id === toggle._id);
    subDAP[Index] = toggle;
    setlistmonth(subDAP);
    calculate(subDAP);

    // seterror("");
    // const { checked } = event.target;
    // const toggle = {
    //   _id: id,
    //   name: name,
    //   chkselected: checked,
    //   disabled: disabled,
    // };
    // const subDAP = [...listmonth];
    // const Index = subDAP.findIndex((x) => x._id === toggle._id);
    // subDAP[Index] = toggle;
    // setlistmonth(subDAP);
    // calculate(subDAP);
  };

const calculate =(sublist) =>{
  const alldata = [...sublist];

    let addall = [];
    let indexstart = 0;
    let monthfrom = 0;
    let monthto = 0;

  for (const dataObj of alldata) {
    if (dataObj.chkselected && dataObj.disabled === false) {
      indexstart = indexstart + 1;

      if (indexstart !== dataObj._id) {
        seterror("ท่านเลือกรายการไม่ถูกต้อง");

        return;
      }
      addall.push(parseInt(dataObj._id));
      monthto = dataObj._id;
    } else if (dataObj.disabled) {
      indexstart = dataObj._id;
      monthfrom = dataObj._id + 1;
    }
  }

  settotalmonth(addall.length);

}

const calTotalfine = (ratefine,finemonth,lastdate) =>{
  let total =0;
  let dayamout = 0;
  if (finemonth > 1) {
    dayamout = 5 * (finemonth-1);
  }else {
    dayamout = finemonth * lastdate;
  } 
  total = (dayamout * ratefine) ;
  
  return (total)

}
  const handleClickUpload = () => {
    const alldata = [...listmonth];
    //  console.log(alldata);
    let addall = [];
    let indexstart = 0;
    let monthfrom = 1;
    let monthto = 0;


    if (payamout == 0) {
      seterror("ระบุยอดเงินก่อน");
      return;
    }

    for (const dataObj of alldata) {
      if (dataObj.chkselected && dataObj.disabled === false) {
        indexstart = indexstart + 1;

        if (indexstart !== dataObj._id) {
          seterror("ท่านเลือกรายการไม่ถูกต้อง");

          return;
        }
        addall.push(parseInt(dataObj._id));
        monthto = dataObj._id;
      } else if (dataObj.disabled) {
        indexstart = dataObj._id;
        monthfrom = dataObj._id + 1;
      }


    }
    if (addall.length === 0) {
      seterror("กรุณาเลือกเดือนก่อน upload");
      return;
    } else if (parseInt(payamout) !== ((addall.length * rate) + (totalfine) )) {

     // console.log((addall.length * rate) + (finerate * chkfine * finedate) )
      seterror("ยอดเงินกับเดือนไม่สัมพันธ์กัน กรุณาติดต่อคุณปริญญา เพื่่อตรวจสอบข้อมูล");
      return;
    }
    setfrom(monthfrom);
    setto(monthto);

    setmonthselect(addall)
    setopenUpload(true);
  };
  const onConfirmUpload = () => {
    setopenUpload(false);
    setenableupload(false);
    seterror("");

  };
  const handleCancleUpload = () => {
    setopenUpload(false);
  };

  const handleAmountChanged = (event) => {
    setpayamout(event.currentTarget.value);
  };
  return (
    <>
      <ModalUpload
        isOpen={openUpload}
        onCancel={handleCancleUpload}
        value={monthselect}
        id={id}
        from={from}
        to={to}
        total={payamout}
        year={year}
        header={"upload slip"}
        onConfirm={onConfirmUpload}
        message="upload สลิปหลักฐานการโอนเงิน"
      />

<div className="row">

<span>เลือกเดือนเพื่อยืนยันการโอน</span>

<span className=""> {"รายเดือน:"} {rate * totalmonth} {" บาท ค่าปรับ:"} {totalfine} {" บาท"}</span>
</div>

   
      <div className="col-lg-11 col-xs-12">
        <Monthtogle
          list={listmonth}
          handleOnClick={handleChangeToggleMonth}
        ></Monthtogle>
      </div>

      <div className="col-12 col-sm-6">
        <div className="form-group">
          <Input
            name="pay"
            value={payamout}
            label="ยอดเงิน"
            type="number"
            onChange={handleAmountChanged}
            error=""
          />
        </div>
      </div>

      {eanableupload && <div className="row d-flex justify-content-center">
        <div className="col-lg-3 mt-2">
            <button className="btn btn-sm btn-success" onClick={handleClickUpload}>
          <FontAwesome name="upload" />
          Upload Slip{" "}
        </button>
        </div>
      
      </div>}
      {error && <div className="col-md-12 alert alert-danger"> {error}</div>}
    </>
  );
};

export default Monthlist;
